import styled, { css } from 'styled-components';

export const LinkStyled = styled.a`
  cursor: pointer;

  ${({ gray }) =>
    gray && `color: var(--ds-text-subtlest, var(--ds-fb-text-subtlest));`}

  ${({ black }) => black && `color: var(--ds-text, var(--ds-fb-text));`}

  ${({ lineHeight }) =>
    css`
      line-height: ${lineHeight};
    `}

  &:hover {
    ${({ gray }) =>
      gray && `color: var(--ds-text-subtle, var(--ds-fb-text-subtle));`}

    ${({ black }) => black && `color: var(--ds-text, var(--ds-fb-text));`}
  }
`;
